import { CSSProperties } from 'react'

const InsertDriveFile = ({ color = '#151515', style }: { color?: string; style?: CSSProperties }) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
            <path
                d="M12 9.2251C14.21 9.2251 16 7.4351 16 5.2251C16 3.0151 14.21 1.2251 12 1.2251C9.79 1.2251 8 3.0151 8 5.2251C8 7.4351 9.79 9.2251 12 9.2251ZM12 3.2251C13.1 3.2251 14 4.1251 14 5.2251C14 6.3251 13.1 7.2251 12 7.2251C10.9 7.2251 10 6.3251 10 5.2251C10 4.1251 10.9 3.2251 12 3.2251ZM12 11.7751C9.64 9.5751 6.48 8.2251 3 8.2251V19.2251C6.48 19.2251 9.64 20.5751 12 22.7751C14.36 20.5851 17.52 19.2251 21 19.2251V8.2251C17.52 8.2251 14.36 9.5751 12 11.7751ZM19 17.3551C16.47 17.6951 14.07 18.6551 12 20.1751C9.94 18.6551 7.53 17.6851 5 17.3451V10.3951C7.1 10.7751 9.05 11.7451 10.64 13.2251L12 14.5051L13.36 13.2351C14.95 11.7551 16.9 10.7851 19 10.4051V17.3551Z"
                fill={color}
            />
        </svg>
    )
}

export default InsertDriveFile
